// Header
(function () {
  let $window  = $(window),
      $body    = $('body'),
      $toggles = $('.js-header-toggle');

  $('.js-header').each(function () {
    let $header     = $(this),
        $navigation = $header.find('.js-header-navigation'),
        $menus      = $header.find('.js-header-menu .menu-item-has-children > a'),
        scrollTop   = 0;

    $header.css('position', 'fixed');
    function scroll() {
      $header[$window.scrollTop() > 0 ? 'addClass' : 'removeClass']('is-fixed');
    }
    scroll();
    $window.on('scroll', scroll);

    $navigation.attr('aria-hidden', true);
    $toggles.attr('role', 'button');
    $toggles.attr('aria-expanded', false);
    $toggles.attr('aria-controls', $navigation.attr('id'));

    // Toggles (overlay, navicon…)
    $toggles.on('click', function (e) {
      e.preventDefault();

      $header.toggleClass('is-active');

      let active = $header.hasClass('is-active');

      $navigation.attr('aria-hidden', !active);
      $toggles.attr('aria-expanded', active);

      if (active) {
        scrollTop = $window.scrollTop();
        $body.css('top', '-' + scrollTop + 'px');
        $body.addClass('is-scroll-disabled');
        $window.off('scroll', scroll);
      } else if ($body.hasClass('is-scroll-disabled')) {
        $body.removeClass('is-scroll-disabled');
        window.scrollTo(0, scrollTop);
        $window.on('scroll', scroll);
      }
    });

    // Submenus
    $menus.each(function (index) {
      let $link    = $(this),
          $item    = $link.parent('.menu-item'),
          $submenu = $link.siblings('.sub-menu'),
          id       = $navigation.attr('id') + '-' + index,
          active   = $item.is('[class*="current"]');

      $submenu.attr('id', id);
      $submenu.attr('aria-hidden', !active);

      $link.attr('role', 'button');
      $link.attr('aria-expanded', active);
      $link.attr('aria-controls', id);

      $link.on('click', function (e) {
        e.preventDefault();

        $item.toggleClass($item.is('[class*="current"]') ? 'is-closed' : 'is-open');

        let active = !$item.hasClass('is-closed');

        $submenu.attr('aria-hidden', !active);
        $link.attr('aria-expanded', active);
      });
    });
  });
})();
